import React from 'react'
import './Mark.css'

const Mark = () => (<div className="mark" />)

export default Mark;
